import * as types from "../actionTypes";

export default function dataPoints(state = {}, action) {
  switch (action.type) {
    case types.DATA_POINT_RECEIVE:
      let dataPoints = { ...state };
      dataPoints[action.payload.type] = action.payload.data;
      return dataPoints;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/company/reducers/dataPoints.js